import * as React from 'react';

import {
  createStyles,
  Theme,
  Typography,
  withStyles,
  WithStyles,
} from '@nelnet/unifi-components-react';

const styles = ({ breakpoints, palette, shape, shadows, spacing }: Theme) =>
  createStyles({
    typographyH1: {
      fontSize: '3em',
      fontWeight: 600,
      color: '#8e44ad',
    },
    customContainer: {
      padding: spacing(4),
      border: `1px solid ${palette.grey[200]}`,
      borderRadius: shape.borderRadius,
      boxShadow: shadows[3],
      [breakpoints.down('sm')]: {
        padding: spacing(2),
        boxShadow: shadows[1],
      },
    },
  });

type ICustomHeadlineProps = WithStyles<typeof styles>;

const UnstyledCustomHeadline: React.FunctionComponent<ICustomHeadlineProps> = ({
  children,
  classes,
}) => {
  return (
    <div className={classes.customContainer}>
      <Typography variant="h1" classes={{ h1: classes.typographyH1 }}>
        {children}
      </Typography>
    </div>
  );
};

const CustomHeadline = withStyles(styles)(UnstyledCustomHeadline);

export default CustomHeadline;
